import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { Ng5SliderModule } from 'ng5-slider';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import {NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ApiClient } from "./shared/api-client.service";
import { Utils } from "./shared/utils";
import { DirectiveModule } from "@bt/directives/directive.module";
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { CoreModule } from "./core";
import { LoginModule, RegistrationModule, BrandModule, RestoreModule, ActivateModule } from "./public";
import { LoginGuard } from './login.guard';
import { ChangePasswordModule } from './public/change-password';
import { SidebarModule } from '@bt/sidebar';
import { AdministrationModule } from "./administration";
import { ProfileModule } from "./profile";
import { AppRoutingModule } from "./app-routing.module";
import { AuthGuard,AuthGuardLoad } from "./auth.guard";
import { LoadPageResolve } from './loadPageResolve';
import { UserGuard } from "./user.guard";
import { CreateAdminModule } from './superadmin/create-admin';
import { UsersProfileModule } from './users-profile';
import { InviteUserModule } from "./admin/invite-user";
import { CreateUserModule } from './admin/create-user';
import { AllUsersModule } from "./admin/all-users";
import { ReactiveFormsModule } from '@angular/forms';
import { DeactivateGuardService } from './deactivate.guard';
import { CryptoBalancesModule } from './crypto-balances/crypto-balances.module';
import { CryptoService } from './core/services/crypto.service';
import { TransactionsModule } from './transactions/transactions.module';
import { WithdrawModule } from './withdraw/withdraw.module';
import { SessionsModule } from './sessions/sessions.module';
import { WithdrawalService } from './core/services/withdrawal.service';
import {BinanceModule} from './binance/binance.module';
import {BinanceService} from './core/services/binance.service';
import { ExchangeModule } from "./exchange/exchange.module";
import { ExchangeService } from "./core/services/exchange.service";
import { StoredJobService } from "./core/services/storedJob.service";
import { AutoCoinPurchaseModule } from "@bt/auto-coin-purchase/auto-coin-purchase.module";
import { JobParametersModalModule } from "@bt/auto-coin-purchase/job-parameters/job-parameters-component.module";
import { ConfirmationModalModule } from "@bt/confirmation-modal/confirmation.module";


const customNotifierOptions: NotifierOptions = {
  position: {
		horizontal: {
			position: 'right',
			distance: 20
		},
		vertical: {
			position: 'bottom',
			distance: 12,
			gap: 10
		}
	},
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    RouterModule,
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreModule.forRoot(),
    NgbModule.forRoot(),
    AppRoutingModule,
    ReactiveFormsModule,
    Ng5SliderModule,
    FormsModule,
    LoginModule,
    BrandModule,
    RegistrationModule,
    RestoreModule,
    InviteUserModule,
    HttpModule,
    AllUsersModule,
    ActivateModule,
    AdministrationModule,
    ProfileModule,
    ProfileModule,
    CreateUserModule,
    ChangePasswordModule,
    SidebarModule,
    CreateAdminModule,
    DirectiveModule,
    NotifierModule.withConfig(customNotifierOptions),
    UsersProfileModule,
    AllUsersModule,
    FontAwesomeModule,
    CryptoBalancesModule,
    TransactionsModule,
    WithdrawModule,
    SessionsModule,
    BinanceModule,
    ExchangeModule,
    ConfirmationModalModule,
    AutoCoinPurchaseModule,
    JobParametersModalModule,
   ],
  providers: [
    AuthGuard,AuthGuardLoad, ApiClient, Utils, LoginGuard, UserGuard, LoadPageResolve,DeactivateGuardService, CryptoService, WithdrawalService, BinanceService,
    ExchangeService, StoredJobService
  ],
  bootstrap: [AppComponent],

})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts